<template>
  <v-layout row>
    <v-flex sm3 xs3>
      <v-select v-model="innerCode" item-text="code" :disabled="disabled" item-value="code" single-line label="Code" style="margin-right:6px" :items="CountryCode">
        <template v-slot:item="{ item }">
          <div style="width:190px; display: flex; justify-Content: space-between;">
            <div>{{ item.name }}</div>
            <div>{{ item.code }}</div>
          </div>
        </template>
      </v-select>
    </v-flex>
    <v-flex sm20 xs20>
      <v-text-field ref="phone" v-model="innerContent" type="number" @blur="checkIsSubmit" :disabled="disabled" validate-on-blur maxlength="14" :rules="[rules.required, ()=> {return rules.phone(phone, code) }]" single-line label="手机号码"  required />
    </v-flex>
  </v-layout>
</template>

<script>
import CountryCode from '@/config/countryCode'
import { validRequired, validPhone, validOtherPhone } from '@/util/validation'
import { http } from '@/api'
import { PublicEvent } from '@/api/collection'
import { dialog } from 'vant'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
    code: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    surveyId: {
      type: String,
      default: ''
    },
    surveyType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      CountryCode,
      innerCode: 86,
      innerContent: '',
      rules: {
        required: validRequired,
        phone: v => {
          if (this.innerCode === 86 && !validPhone(this.innerContent)) {
            return '手机号格式不正确'
          } else if (this.innerCode !== 86 && !validOtherPhone(this.innerContent)) {
            return '手机号格式不正确'
          } else {
            return ''
          }
        }
      }
    }
  },
  watch: {
    innerContent(n) {
      this.$emit('update:phone', n)
    },
    innerCode(n) {
      this.$emit('update:code', n)
    }
  },
  created() {
    this.innerCode = this.code
    this.innerContent = this.phone
  },
  methods: {
    // 检查是否已报名活动
    async checkLeadIsRegistered(data){
        const res = await http({
          path: PublicEvent.CheckLeadIsRegistered.path,
          method: PublicEvent.CheckLeadIsRegistered.method,
          data
        })
        if(res.resultCode === '0' ){
            if(res.data === true){ // true表示已报名
              dialog.alert({
                message: '您已提交过报名，请勿重复报名'
              }).then(() => {
                  this.$emit('getShowVerifyDialog', false)
                  this.$emit('applyStatus', '0')  // 0已报名过活动    
                  // this.$parent.$parent.showThanksPage(true)
                  this.$emit('submited',true)
              }).catch(() => {
                // cancel return, do nothing
              })            
            }
        }
    },
    checkIsSubmit(){
         if(this.surveyType === 'EREG'){
            this.checkLeadIsRegistered({surveyId: this.surveyId,  eventId: this.$route.query.id, phoneNumber: this.innerContent})
         }
    }
  }
}
</script>
